import LsdApiModel from './global/LsdApiModel';

export default class MeModel extends LsdApiModel {
	static get path(): string {
		return '/users/me';
	}
}
